import ConnectivityIssuesTemplate from '@/components/templates/connectivityIssues/connectivityIssuesTemplate'

export default function ConnectivityIssuesPage() {
    return (
        <div className="connectivity-issues-page">
            <ConnectivityIssuesTemplate />
        </div>
    )
}
